export enum AccountSector {
    Legacy = 1,
    WasteRecycling,
    Security,
    Aggregate,
    Agricultural = 5,
    Horticultural,
    FacilitiesManagement,
    Haulage,
    Parcel,
    Finance,
    Hospitality,
    CustomerServices,
    Construction,
    Laundry,
    FoodBeverage,
    PassengerServices,
    Other,
    Utilities,
    ConsumerGoods,
    Leisure,
    Logistics,
    Retail,
    Pharmaceutical
}
